import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`El capell d’aquest bolet primer és acampanat obrint-se fins arribar a ser totalment pla fins a 9 cm de diàmetre amb o sense mamelló central. Presenta un marge estriat i una coloració entre groc i rogenc ataronjat, un poc més fosc al centre. Les làmines són blanques, fines i atapeïdes. El peu és llarg amb esquames peludes i presenta a la base una volva elevada de color blanquinós. Les espores són blanques en massa, esfèriques, d’10-12 micres.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      